export const generateShortDateFormat = (isoDate: string) => {
  try {
    const date = new Date(isoDate);

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    const shortMonths = [
      'янв',
      'фев',
      'мар',
      'апр',
      'май',
      'июн',
      'июл',
      'авг',
      'сен',
      'окт',
      'ноя',
      'дек',
    ];

    const shortMonth = shortMonths[monthIndex];

    return `${day} ${shortMonth} ${year}`;
  } catch (e) {
    console.error(e);
    return isoDate;
  }
};

export const generateFullDateFormat = (isoDate: string) => {
  try {
    const date = new Date(isoDate);

    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    };

    const formatter = new Intl.DateTimeFormat('ru-RU', options);

    return formatter.format(date);
  } catch (e) {
    console.error(e);
    return isoDate;
  }
};
